module.exports = __webpack_public_path__ + "static/media/overuse.dd5e0bbd.svg";